// Copyright 2023 Sorama B.V.

import { Unit, UnitType } from "units/Unit";
import { CompositeUnit } from "./CompositeUnit";
import { Currency } from "./Currency";
import { Time } from "./Time";

export class Energy extends UnitType {
    public static override typeName = "Energy";

    public static joules: Unit = new Unit("J", 1, Energy);
    public static kiloJoules: Unit = new Unit("kJ", 1e3, Energy);
    public static megaJoules: Unit = new Unit("MJ", 1e6, Energy);

    public static wattHours: Unit = new Unit("Wh", 3.6e3, Energy);
    public static kiloWattHours: Unit = new Unit("kWh", 3.6e6, Energy);
    public static megaWattHours: Unit = new Unit("MWh", 3.6e9, Energy);
}

export class EnergyCost extends UnitType {
    public static override typeName = "Energy Cost";

    public static euroPerKiloWattHour: CompositeUnit = new CompositeUnit(
        Currency.EUR,
        Energy.kiloWattHours,
        EnergyCost,
        {
            aliases: ["EUR/kWh", "€/kWh"],
        }
    );
    public static usdPerKiloWattHour: CompositeUnit = new CompositeUnit(
        Currency.USD,
        Energy.kiloWattHours,
        EnergyCost,
        {
            aliases: ["USD/kWh", "$/kWh"],
        }
    );
    public static euroPerMegaWattHour: CompositeUnit = new CompositeUnit(
        Currency.EUR,
        Energy.megaWattHours,
        EnergyCost,
        {
            aliases: ["EUR/MWh", "€/MWh"],
        }
    );
    public static usdPerMegaWattHour: CompositeUnit = new CompositeUnit(
        Currency.USD,
        Energy.megaWattHours,
        EnergyCost,
        {
            aliases: ["USD/MWh", "$/MWh"],
        }
    );
    public static euroPerKiloJoule: CompositeUnit = new CompositeUnit(Currency.EUR, Energy.kiloJoules, EnergyCost, {
        aliases: ["EUR/kJ", "€/kJ"],
    });
    public static usdPerKiloJoule: CompositeUnit = new CompositeUnit(Currency.USD, Energy.kiloJoules, EnergyCost, {
        aliases: ["USD/kJ", "$/kJ"],
    });
}

export class EnergyUsage extends UnitType {
    public static override typeName = "EnergyUsage";

    public static kiloWattHoursPerYear: CompositeUnit = new CompositeUnit(
        Energy.kiloWattHours,
        Time.year,
        EnergyUsage,
        {
            aliases: ["kWh/year", "kWh per year"],
        }
    );
    public static megaWattHoursPerYear: CompositeUnit = new CompositeUnit(
        Energy.megaWattHours,
        Time.year,
        EnergyUsage,
        {
            aliases: ["MWh/year", "MWh per year"],
        }
    );
}
